import { useDispatch } from 'react-redux';
import { updateNewsletters } from '@client/myAccount/newsletters/redux/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useUpdateNewslettersAction = (): typeof updateNewsletters => {
  const dispatch = useDispatch();

  return bindActionCreators(updateNewsletters, dispatch);
};
